import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import withRouter from "../../../common/withRouter";
import { useQuery } from "react-query";
import { logout } from "../services/authApi";

const Logout = () => {
  const [isUserLogout, setIsUserLogout] = useState(false);

  const logoutQuery = useQuery({
    queryKey: ["logout"],
    queryFn: logout,
  });

  useEffect(() => {
    if (logoutQuery.status === "success") {
      sessionStorage.removeItem("authUser");
      sessionStorage.removeItem("authAdmin");
      sessionStorage.removeItem("twoFaUser");
      sessionStorage.removeItem("twoFaAdmin");
      localStorage.removeItem("backupAdmin"); // très important !
      localStorage.removeItem("persist:root");
      // Optionnel mais propre
      sessionStorage.clear();

      setIsUserLogout(true);
    }
  }, [logoutQuery.status]);

  if (isUserLogout) {
    return <Navigate to="/login" replace />;
  }

  return null;
};
Logout.propTypes = {
  history: PropTypes.object,
};

export default withRouter(Logout);
